import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { tryCatch, always, is } from 'ramda';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getFromProvider = function getFromProvider(provider, key) {
  var storedValue = provider.getItem(key);
  return tryCatch(function (value) {
    return JSON.parse(value);
  }, always(storedValue))(storedValue);
};
var attachToProvider = function attachToProvider(provider, key, data) {
  var currentSession = getFromProvider(provider, key) || {};
  if (is(String, currentSession)) {
    throw new Error('You cannot attach data to string value.');
  }
  provider.setItem(key, JSON.stringify(_objectSpread(_objectSpread({}, currentSession), data)));
};
var AppSession = /*#__PURE__*/function () {
  function AppSession(_ref) {
    var _ref$sessionProvider = _ref.sessionProvider,
      sessionProvider = _ref$sessionProvider === void 0 ? sessionStorage : _ref$sessionProvider,
      _ref$sessionItemName = _ref.sessionItemName,
      sessionItemName = _ref$sessionItemName === void 0 ? 'SESSION_STORE' : _ref$sessionItemName,
      _ref$sessionItemRoleN = _ref.sessionItemRoleName,
      sessionItemRoleName = _ref$sessionItemRoleN === void 0 ? 'SESSION_STORE_ROLE' : _ref$sessionItemRoleN;
    _classCallCheck(this, AppSession);
    this.sessionProvider = sessionProvider;
    this.sessionItemName = sessionItemName;
    this.sessionItemRoleName = sessionItemRoleName;
  }
  return _createClass(AppSession, [{
    key: "create",
    value: function create(sessionData) {
      attachToProvider(this.sessionProvider, this.sessionItemName, sessionData);
    }
  }, {
    key: "set",
    value: function set(sessionData) {
      attachToProvider(this.sessionProvider, this.sessionItemName, sessionData);
    }
  }, {
    key: "get",
    value: function get() {
      return getFromProvider(this.sessionProvider, this.sessionItemName);
    }
  }, {
    key: "add",
    value: function add(nodeName, nodeData) {
      attachToProvider(this.sessionProvider, this.sessionItemName, _defineProperty({}, nodeName, nodeData));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var exitNavigation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.sessionProvider.removeItem(this.sessionItemName);
      this.sessionProvider.removeItem(this.sessionItemRoleName);
      if (exitNavigation) {
        // window.location.reload();
        window.location.replace('/'); // because doesnt exist this route
      }
    }
  }, {
    key: "createRoles",
    value: function createRoles(roles) {
      attachToProvider(this.sessionProvider, this.sessionItemRoleName, roles);
    }
  }, {
    key: "getRoles",
    value: function getRoles() {
      return getFromProvider(this.sessionProvider, this.sessionItemRoleName);
    }
  }]);
}();

export { AppSession as A };
